exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".invest-accordion svg[data-v-44c8cfa6]:focus{outline:none}[data-v-44c8cfa6] td.exist_error{border:1px solid red}.pdfFiles[data-v-44c8cfa6]{padding-left:0;font-size:120%;margin-top:10px;text-transform:uppercase;font-weight:700;border-bottom:none!important}.pdfFiles .show-deleted-checkbox[data-v-44c8cfa6]{font-size:90%!important;text-transform:lowercase;font-weight:400}.bg-disable[data-v-44c8cfa6]{background:#d3d3d3}label.has-error[data-v-44c8cfa6]{color:#dc3545}", ""]);

// exports
